// COD offset (PD-2333): part of a Credit User's COD remittance can be used to settle UNBILLED
// billing charges of the same calendar month. The server proposes the charges (report.codOffset)
// and re-validates the final selection on /api/payout/pay; this only guards the button.

// Whole cents, so floating point never decides a limit.
export const toCents = (amount) => Math.round((Number(amount) || 0) * 100);

export const formatCents = (cents) => (cents / 100).toFixed(2);

// report is one merchant entry from /api/payout/process-bulk. blockReason is set when the payout
// must not go ahead; an empty selection is allowed and means "offset nothing".
export const getOffsetSummary = ({ report, selectedIds = [], codAmount, adjustmentValue }) => {
  const codCents = toCents(codAmount);
  const adjustmentCents = toCents(adjustmentValue);

  if (report.codOffsetError) {
    return {
      offsetCents: 0,
      remainingCents: codCents + adjustmentCents,
      blockReason: `COD offset could not be loaded: ${report.codOffsetError}`,
    };
  }

  if (!report.codOffset) {
    return { offsetCents: 0, remainingCents: codCents + adjustmentCents, blockReason: null };
  }

  const selectedSet = new Set(selectedIds);
  const selected = report.codOffset.charges.filter((charge) => selectedSet.has(charge.id));
  const offsetCents = selected.reduce((sum, charge) => sum + toCents(charge.amount), 0);
  const remainingCents = codCents - offsetCents + adjustmentCents;

  let blockReason = null;
  if (selected.length > 0 && offsetCents <= 0) {
    blockReason = "The selected charges net to zero or less. Untick them to offset nothing.";
  } else if (offsetCents > codCents) {
    blockReason = `The selected charges (RM ${formatCents(offsetCents)}) are more than the COD amount (RM ${formatCents(
      codCents
    )}).`;
  } else if (remainingCents < 0) {
    blockReason = "The payout after offset and adjustment would be negative.";
  }

  return { offsetCents, remainingCents, blockReason };
};
